const html = require('choo/html');

let createsDomNodes;

/**
 * Node SSR 下 choo/html 返回编码后的 String；若 global.window 被 polyfill，
 * 不能再用 typeof window 判断。以返回值是否具备 DOM API 为准。
 */
function nanohtmlCreatesDomNodes() {
  if (createsDomNodes !== undefined) return createsDomNodes;
  const node = html`<span class="_send_kq_probe"></span>`;
  createsDomNodes = !!(
    node &&
    typeof node.getElementsByClassName === 'function'
  );
  return createsDomNodes;
}

module.exports = { nanohtmlCreatesDomNodes };
